import { atom } from "jotai";

export const isOpenAuth = atom(false);
export const isLogin = atom(false);
export const isResetPasswordAtom = atom(false);